import IconCartActive from '@/assets/icons/cart/shopping-cart-added.svg';
import ShoppingCart from '@/assets/icons/cart/shopping-cart.svg';
import IconArrowLeft from '@/assets/icons/icon-arrow-left.svg';
import IconArrowRight from '@/assets/icons/icon-arrow-right.svg';
import Phone from '@/assets/images/cart/phone.png';
import {
  DraftOrderCreateMutation,
  useDefaultChannelQuery,
  useDraftOrderCreateMutation,
  useDraftOrderLineCreateMutation,
} from '@/graphql';
import convertToReadable from '@/helpers/convertToReadable';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';
import Image from 'next/image';
import { useRouter } from '@/i18n/navigation';
import { Key, useEffect, useRef, useState } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { Accordion, Button } from 'rsuite';
import styles from './styles.module.scss';
import { ordersStore } from '@/zustand/orders';
import useUserStore from '@/zustand/useUser';
import { useGuestStore } from '@/zustand/guestStore';
import { useTranslations } from 'next-intl';
import { decodeBase64Id } from '@/helpers/decodeBase64Id';
import DefaultProductPlaceholder from '@/assets/images/Yellow.png';

const tabsData = ['Смартфон', 'Наушники', 'Смарт-часы'];

const images = [
  {
    src: Phone,
    alt: 'Rasm 1',
    title: 'Xiaomi 14 12/512GB Jade Green',
    color: 'White',
    price: '100000',
  },
  {
    src: Phone,
    alt: 'Rasm 2',
    title: 'Xiaomi 14 12/512GB Jade Green',
    color: 'Black',
    price: '125000',
  },
  {
    src: Phone,
    alt: 'Rasm 3',
    title: 'Xiaomi 14 12/512GB Jade Green',
    color: 'White',
    price: '600000',
  },
];

export default function ProductAccardion({
  draftOrdersData,
  similarProducts,
  refetchDraftOrders,
}: any) {
  const [tab, setTab] = useState(similarProducts?.[0]?.category?.id);
  const [activeKey, setActiveKey] = useState<any>(0);
  const [loadingStates, setLoadingStates] = useState<Record<string, boolean>>(
    {}
  );
  const orderId = useGuestStore(state => state.guestOrderId);
  const userData = useUserStore((user: any) => user?.user);
  const isLoggedIn = Boolean(userData?.id);
  const router = useRouter();
  const splideRef = useRef<any>(null);
  const { data: channelData } = useDefaultChannelQuery();
  const [openCartModal, setOpenCartModal] = useState(false);
  const setOrders = ordersStore(e => e.setOrders);

  const [addProductOrderLineToCart] = useDraftOrderLineCreateMutation({
    context: {
      requiresAuth: true,
    },
    onCompleted: () => {
      refetchDraftOrders();
    },
  });

  const filteredProducts = similarProducts?.filter(
    (item: any) => item?.category?.id === tab
  );
  const combinedProducts =
    filteredProducts?.flatMap((item: any) => {
      if (item?.similarProducts?.edges?.length > 0) {
        return item.similarProducts.edges.map((edge: any) => edge.node);
      }
      return []; // if no edges, return empty array
    }) || [];

  useEffect(() => {
    if (similarProducts?.length > 0) {
      setTab(similarProducts?.[0]?.category?.id);
    }
  }, [similarProducts]);

  const handleCartOpen = () => {
    setOpenCartModal(true);
  };

  const handleCartClose = () => {
    setOpenCartModal(false);
  };

  const handleSuccessOrder = (data: DraftOrderCreateMutation) => {
    if (data?.draftOrderCreate?.errors?.length === 0) {
      setOrders(data?.draftOrderCreate?.order);
      refetchDraftOrders();
    }
  };

  const [addProductToCart] = useDraftOrderCreateMutation({
    context: {
      requiresAuth: true,
    },
    onCompleted: handleSuccessOrder,
  });

  const addToCart = async (id: any) => {
    try {
      if (isLoggedIn) {
        if (draftOrdersData?.userDraftOrders?.length === 0) {
          await addProductToCart({
            variables: {
              input: {
                channelId: channelData?.channel?.id,
                user: userData?.id,
                lines: [
                  {
                    variantId: id,
                    quantity: 1,
                  },
                ],
              },
            },
          });
        }
        if (draftOrdersData?.userDraftOrders?.[0]?.isFastBuy === false) {
          await addProductOrderLineToCart({
            variables: {
              id: draftOrdersData?.userDraftOrders?.[0]?.id,
              input: [
                {
                  variantId: id,
                  quantity: 1,
                },
              ],
            },
          });
        }
        // TO CLEAN LOCAL STORAGE AFTER LOGGIN
        // useGuestStore.getState().clearGuestOrderId();
      } else {
        if (!orderId) {
          const orderGuestData = await addProductToCart({
            variables: {
              input: {
                channelId: channelData?.channel?.id,
                lines: [
                  {
                    variantId: id,
                    quantity: 1,
                  },
                ],
              },
            },
          });
          const guestOrderId =
            orderGuestData?.data?.draftOrderCreate?.order?.id;
          typeof guestOrderId === 'string' &&
            useGuestStore.getState().setGuestOrderId(guestOrderId);
        } else {
          await addProductOrderLineToCart({
            variables: {
              id: orderId,
              input: [
                {
                  variantId: id,
                  quantity: 1,
                },
              ],
            },
          });
        }
      }
      handleCartOpen();
    } catch (error) {
      console.error('Error on adding item to basket: ', error);
    }
  };
  const goToNextSlide = () => {
    const splide = splideRef.current?.splide;
    if (splide) {
      splide.go('>');
    }
  };

  const goToPrevSlide = () => {
    const splide = splideRef.current?.splide;
    if (splide) {
      splide.go('<');
    }
  };

  const onClick = (e: any) => {
    if (e === activeKey) {
      setActiveKey(0);
    } else {
      setActiveKey(e);
    }
  };

  const isProductInCart = (productId: any) => {
    if (isLoggedIn) {
      return draftOrdersData?.userDraftOrders?.[0]?.lines?.some(
        (line: any) => line?.productVariantId === productId
      );
    }
    return draftOrdersData?.draftOrder?.lines?.some(
      (line: any) => line?.productVariantId === productId
    );
  };
  const t = useTranslations('Components.product-accordion');
  return (
    <>
      {filteredProducts?.length > 0 ? (
        <div className={styles.accordionRoot}>
          <Accordion activeKey={activeKey} onSelect={onClick}>
            <Accordion.Panel
              eventKey={1}
              caretAs={() =>
                activeKey === 1 ? (
                  <IoIosArrowUp style={{ fontSize: '24px' }} />
                ) : (
                  <IoIosArrowDown style={{ fontSize: '24px' }} />
                )
              }
              header={
                <div className={styles.accordionHeader}>
                  <div className={styles.accordionHeaderLeft}>
                    <h5 className={styles.leftTitle}>{t('accessories')}</h5>
                    <p className={styles.leftSubTitle}>
                      {similarProducts?.length} {t('items')}
                    </p>
                  </div>
                  {activeKey !== 1 && (
                    <div className={styles.accordionHeaderRight}>
                      {similarProducts
                        ?.slice(0, 3)
                        .map(
                          (product: {
                            id: Key | null | undefined;
                            thumbnail: { url: string | StaticImport };
                          }) => (
                            <Image
                              key={product?.id}
                              width={60}
                              height={50}
                              style={{
                                width: '100%',
                                height: 'auto',
                              }}
                              src={
                                product?.thumbnail?.url
                                  ? product?.thumbnail?.url
                                  : DefaultProductPlaceholder
                              }
                              alt="Accordion image"
                            />
                          )
                        )}
                    </div>
                  )}
                </div>
              }
            >
              <div className={styles.tabsBox}>
                {[
                  ...new Map(
                    similarProducts?.map((item: any) => [
                      item?.category?.id,
                      item,
                    ])
                  ).values(),
                ]?.map((item: any, id: any) => (
                  <div
                    key={id}
                    onClick={() => setTab(item?.category?.id)}
                    className={`${styles.tabText} ${
                      item?.category?.id === tab
                        ? styles.tabTextActive
                        : styles.tabText
                    }`}
                  >
                    {item?.category?.name}
                  </div>
                ))}
              </div>

              <div>
                {filteredProducts?.length > 0 && (
                  <div className={styles.sliderRoot}>
                    <Splide
                      ref={splideRef}
                      options={{
                        type: 'loop',
                        rewind: true,
                        updateOnMove: true,
                        perPage: 3,
                        perMove: 1,
                        arrows: false,
                        pagination: false,
                        gap: '12px',
                        breakpoints: {
                          1220: { perPage: 2, gap: '8px' },
                          991: { perPage: 2, gap: '8px' },
                          768: { perPage: 2, width: '100%', gap: '8px' },
                          600: { perPage: 1, width: '100%', gap: '8px' },
                        },
                      }}
                      hasTrack={false}
                      style={{ padding: '0' }}
                    >
                      <SplideTrack>
                        {filteredProducts?.map(
                          (product: any, index: number) => {
                            const displayVariant =
                              product?.defaultVariant || product?.variants?.[0];
                            return (
                              <SplideSlide key={index}>
                                <div
                                  className={styles.sliderWrapper}
                                  onClick={() =>
                                    router.push(
                                      `/product//${decodeBase64Id(displayVariant?.id)}-${displayVariant?.product.slug}`
                                    )
                                  }
                                >
                                  <div className={styles.leftSide}>
                                    <Image
                                      src={
                                        displayVariant?.media?.[0]?.url ||
                                        DefaultProductPlaceholder
                                      }
                                      width={80}
                                      height={75}
                                      style={{
                                        width: '100%',
                                        height: 'auto',
                                      }}
                                      alt={product?.title || 'Product Image'}
                                      layout="responsive"
                                      className={styles.sliderTopImage}
                                    />
                                  </div>
                                  <div className={styles.rightSide}>
                                    <h6 className={styles.sliderTopTitle}>
                                      {displayVariant?.name || 'No title'}
                                    </h6>
                                    <div className={styles.bottomContent}>
                                      <p>
                                        {convertToReadable(
                                          displayVariant?.pricing?.price?.net
                                            ?.amount || 0
                                        )}{' '}
                                        {t('price')}
                                      </p>
                                      <div
                                        className={styles.sliderBottomCircle}
                                      >
                                        {isProductInCart(displayVariant?.id) ? (
                                          <Button
                                            type="button"
                                            onClick={e => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                              router.push('/cart');
                                            }}
                                            className={styles.icon}
                                            disabled={
                                              loadingStates[displayVariant?.id]
                                            }
                                          >
                                            <IconCartActive />
                                          </Button>
                                        ) : (
                                          <Button
                                            type="button"
                                            onClick={e => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                              addToCart(displayVariant?.id);
                                            }}
                                            className={styles.cart}
                                            disabled={
                                              loadingStates[displayVariant?.id]
                                            }
                                          >
                                            <ShoppingCart />
                                          </Button>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </SplideSlide>
                            );
                          }
                        )}
                      </SplideTrack>

                      <button
                        type="button"
                        className={styles.carouselPrevButton}
                        onClick={goToPrevSlide}
                      >
                        <IconArrowLeft />
                      </button>
                      <button
                        type="button"
                        className={styles.carouselNextButton}
                        onClick={goToNextSlide}
                      >
                        <IconArrowRight />
                      </button>
                    </Splide>
                  </div>
                )}
              </div>
            </Accordion.Panel>
          </Accordion>
        </div>
      ) : null}
    </>
  );
}
